









import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  inheritAttrs: false,
})
export default class FilterPanel extends Vue {
  @Prop({ type: String, default: "" }) title!: string;
  @Prop({ type: String, default: "div" }) tag!: string;
}
